import React from 'react';
import { Quote } from 'lucide-react';
import { TESTIMONIALS } from '../mock';

const Testimonials = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0d3d5e]">
            What Our Clients Say
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Trusted by Perth businesses for reliable, professional refrigerated
            transport.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t) => (
            <figure
              key={t.name}
              className="p-8 rounded-lg bg-slate-50 border border-slate-100 flex flex-col"
            >
              <Quote className="w-8 h-8 text-[#0d3d5e]/40" />
              <blockquote className="mt-4 text-slate-700 text-base leading-relaxed flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-slate-200">
                <div className="font-bold text-[#0d3d5e]">{t.name}</div>
                <div className="text-sm text-slate-500 mt-1">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
